/**
 * Created by lu on 2017/9/14.
 */
var io = require('./io');
module.exports = function (inOpts) {
    inOpts.cmd = 'index/module';
    io.ajax(inOpts);
};


//////////////////
// WEBPACK FOOTER
// ../src/js/io/product/getIndexModule.js
// module id = 407
// module chunks = 1